import React, { useEffect, useState, useContext } from 'react';
import * as S from './styles';
import { Context } from '../../services/contexts/StateContext';
import MaskedInput from 'react-text-mask';
import api from '../../services/api';
import { useLocation } from 'react-router-dom';
// -----------------------

import { Functions } from '../Functions';
import { Api_Clientes } from '../../services/FiltrosApi/clienteApi';
import { ApiEvento } from '../../services/FiltrosApi/eventoApi';
import { Api_Veiculos } from '../../services/FiltrosApi/veiculos_api';

// -----------------------
export function CondutorEvento({ 
    setCarregarTela, CondutorAssociado, condutorOutro, titulo,
    setOutroCondutor, setCondutorAssociado, setTipoVistoria, setModalCondutor, tipoVistoria, FecharModal, PesqIdEvento, onConfirmarCadastro }) {

    const { state, dispatch } = useContext(Context);
    const { evento } = state.evento;
    const { cliente } = state.cliente;
    const { veiculo } = state.veiculo;
    const { listaPesquisa, playmodal } = state.parametros;
    // ----------------------

    // Estados para modal de data
    const [dataDigitada, setDataDigitada] = useState('');
    const [erroModalData, setErroModalData] = useState('');

    const [nomeCondutor, setNomeCondutor] = useState('');
    const [cpfCondutor, setCpfCondutor] = useState('');
    const [celular, setCelular] = useState('');

    const [erroNome, setErroNome] = useState('');
    const [erroCpf, setErroCpf] = useState('');
    const [erroCelular, setErroCelular] = useState('');
    const [mensagemErro, setMensagemErro] = useState('');

    const [ConfirmarCondutor, setConfirmarCondutor] = useState(false);
    const [ConfirmarAssociado, setConfirmarAssociado] = useState(false);

    // -------------------------
    
    const [editandoCelular, setEditandoCelular] = useState(false);
    const [celularModificado, setCelularModificado] = useState(false);
    const [paginaADD, setPaginaADD] = useState(false);
    // ----------------------
    const { AddCPF } = Api_Clientes();
    const { AddSimplesEvento, AtualizarSimples } = ApiEvento();
    const { AtualizarVeiculo } = Api_Veiculos();
    const { PesqCPFdigitando } = Functions();
    const localRota = useLocation();
    const tituloExibido = tipoVistoria === 'vistoria_cadastro'
        ? 'PROPRIETARIO DO VEICULO'
        : titulo;
    
    // ###################################################
    
    function SetListaPesquisa(key, value) {
        dispatch({
            type: 'set_ListaPesquisa',
            payload: { ...listaPesquisa, [key]: value }
        });
    };
    // --------------

    useEffect(() => {
        if (localRota.pathname === "/") {
            setPaginaADD(true);
        }
    }, []);

    // Efeito para validar CPF automaticamente após 11 dígitos
    useEffect(() => {
        const localizarAssociado = async () => {
            if (cpfCondutor) {
                const documentoLimpo = cpfCondutor.replace(/\D/g, '');
                if (documentoLimpo.length === 11 || documentoLimpo.length === 14) {
                    const localizado = await PesqCPFdigitando(documentoLimpo);
                    setCelular(localizado?.foneCelular?.numeroCel || '');
                    dispatch({
                        type: 'set_cliente',
                        payload: {
                            ...cliente,
                            id_Cliente: localizado?._id,
                            nome: localizado?.nome,
                            cpfCnpj: localizado?.cpfCnpj,
                            celular: localizado?.foneCelular?.numeroCel,
                        }
                    });
                }
            }
        };
        localizarAssociado();

    }, [cpfCondutor]);
    // -------------------------------------

    // Função para validar CPF-------------------
    const validarCPF = (cpfDigitado) => {
        const cpfLimpo = cpfDigitado.replace(/\D/g, '');
        
        if (cpfLimpo.length !== 11) {
            return false;
        }
        
        if (/^(\d)\1{10}$/.test(cpfLimpo)) {
            return false;
        }
        
        let soma = 0;
        let resto;
        
        for (let i = 1; i <= 9; i++) {
            soma += parseInt(cpfLimpo.substring(i - 1, i)) * (11 - i);
        }
        
        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(cpfLimpo.substring(9, 10))) return false;
        
        soma = 0;
        for (let i = 1; i <= 10; i++) {
            soma += parseInt(cpfLimpo.substring(i - 1, i)) * (12 - i);
        }
        
        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(cpfLimpo.substring(10, 11))) return false;
        
        return true;
    };

    const validarCNPJ = (cnpjDigitado) => {
        const cnpjLimpo = cnpjDigitado.replace(/\D/g, '');

        if (cnpjLimpo.length !== 14) {
            return false;
        }

        if (/^\d{14}$/.test(cnpjLimpo) && /^([0-9])\1*$/.test(cnpjLimpo)) {
            return false;
        }

        let tamanho = cnpjLimpo.length - 2;
        let numeros = cnpjLimpo.substring(0, tamanho);
        const digitos = cnpjLimpo.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
            soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
            if (pos < 2) pos = 9;
        }

        let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado !== parseInt(digitos.charAt(0))) {
            return false;
        }

        tamanho = tamanho + 1;
        numeros = cnpjLimpo.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
            soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
            if (pos < 2) pos = 9;
        }

        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        return resultado === parseInt(digitos.charAt(1));
    };

    const validarDocumento = (documentoDigitado) => {
        const documentoLimpo = documentoDigitado.replace(/\D/g, '');

        if (documentoLimpo.length === 11) {
            return validarCPF(documentoDigitado);
        }

        if (documentoLimpo.length === 14) {
            return validarCNPJ(documentoDigitado);
        }

        return false;
    };

    // Função para validar Celular
    const validarCelular = (celularDigitado) => {
        const celularLimpo = celularDigitado.replace(/\D/g, '');
        return celularLimpo.length === 11 || celularLimpo.length === 10;
    };

    // Função para obter data máxima (hoje)
    const getDataMaxima = () => {
        const hoje = new Date();
        const ano = hoje.getFullYear();
        const mes = String(hoje.getMonth() + 1).padStart(2, '0');
        const dia = String(hoje.getDate()).padStart(2, '0');
        return `${ano}-${mes}-${dia}`;
    };

    // Função para atualizar apenas o celular---------------
    const atualizarCelular = async () => {
        setErroCelular('');
        setMensagemErro('');
        let temErros = false;

        // Validar Celular
        if (!celular || celular.trim() === '') {
            setErroCelular('Por favor, insira o número de celular.');
            temErros = true;
        } else if (!validarCelular(celular)) {
            setErroCelular('Celular inválido. Use formato (XX) 9XXXX-XXXX ou (XX) XXXX-XXXX.');
            temErros = true;
        }

        if (temErros) {
            setMensagemErro('Corrija o número de celular para continuar.');
            return false;
        }

        let sucesso = false;

        // Atualizar apenas o celular
        dispatch({
            type: 'set_Evento',
            payload: {
                ...evento,
                telefoneCondutor: celular.replace(/\D/g, '')
            }
        });

        await api.put(`cliente/atualizar/${cliente.id_Cliente}`,{
            foneCelular: {
                numeroCel: celular.replace(/\D/g, '')
            }
        })
        .then(res => {
            dispatch({
                type: 'set_Evento',
                payload: {
                    ...evento,
                    telefoneCondutor: res.data.foneCelular.numeroCel,
                }
            });
            dispatch({
                type: 'set_cliente',
                payload: {
                    ...cliente,
                    celular: res.data.foneCelular.numeroCel,
                }
            });
            alert("Celular Atualizado");
            sucesso = true;

        }).catch(()=> setMensagemErro("Não foi possível atualizar o celular. Tente novamente."))

        if (sucesso) {
            setCelularModificado(false);
            setEditandoCelular(false);
        }
        return sucesso;
    };

    // Confirma o condutor apenas com celular cadastrado; senão exige preencher e atualizar antes
    const confirmarCondutorCadastro = async () => {
        if (!cliente.id_Cliente || !veiculo.id_ClienteVeiculo) {
            AddCliente_Veiculo();
            return;
        }
        if (!cliente.celular || celularModificado) {
            setEditandoCelular(true);
            if (!await atualizarCelular()) return;
        }
        setCondutorAssociado(false);
        setModalCondutor(false);
        if (onConfirmarCadastro) onConfirmarCadastro();
    };

    // Função para salvar CPF----------------
    const AddCliente_Veiculo = async () => {
        setCarregarTela(false);

        if(!cliente.id_Cliente) {
            const payloadPessoa = {
                nome: nomeCondutor.trim(),
                cpf: cpfCondutor.replace(/\D/g, ''),
                celular: celular.replace(/\D/g, '')
            };

            const retorno = await AddCPF(payloadPessoa);
            if (!retorno?._id) {
                setMensagemErro('Não foi possível cadastrar o cliente. Verifique os dados e tente novamente.');
                setCarregarTela(true);
                return;
            }
            if (retorno._id) {
                setConfirmarAssociado(true); 
                AtualizarVeiculo({ idCliente: retorno._id });
                setOutroCondutor(false);
                if (tipoVistoria === "vistoria_cadastro") {
                    setCondutorAssociado(false);
                    
                }else {
                    setCondutorAssociado(true);
                }

                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: {
                        ...listaPesquisa,
                        nomeItem: "",
                        selectItem: '',
                    }
                });
            }
        } else {
            if (!veiculo.id_ClienteVeiculo) {
                const retorno = await AtualizarVeiculo({ idCliente: cliente.id_Cliente });
                if (retorno?._id || (retorno && !(retorno instanceof Error))) {
                    setConfirmarAssociado(true); 
                } else {
                    setMensagemErro('Não foi possível associar o cliente ao veículo. Tente novamente.');
                    setCarregarTela(true);
                }
            }
        };
    };
    // -----------------------------------------------------

    useEffect(() => {
        if (veiculo.id_ClienteVeiculo) {
            setConfirmarAssociado(true)
        }
      
    }, [veiculo.id_ClienteVeiculo]);
    // -------------------------------------
    const SalvarEvento = async () => {
        setErroModalData('');
        setMensagemErro('');
        setErroNome('');
        setErroCpf('');
        setErroCelular('');
        let temErros = false;

        // O CPF digitado só existe ao cadastrar um novo condutor; no associado/condutor já selecionado vem do cliente
        const documento = cpfCondutor || cliente.cpfCnpj || '';
        const documentoLimpo = documento.replace(/\D/g, '');
        const mensagens = [];

        if (documentoLimpo.length < 11 || documentoLimpo.length > 14) {
            setErroCpf('Informe um CPF ou CNPJ válido.');
            mensagens.push('CPF/CNPJ');
            temErros = true;
        } else if (!validarDocumento(documento)) {
            setErroCpf('CPF ou CNPJ inválido.');
            mensagens.push('CPF/CNPJ');
            temErros = true;
        }

        // Validar Celular
        if (!celular && !cliente.celular) {
            setErroCelular('Por favor, insira o número de celular!');
            mensagens.push('celular');
            temErros = true;
        } else if (!validarCelular(celular || cliente.celular)) {
            setErroCelular('Celular inválido. Use formato (XX) 9XXXX-XXXX ou (XX) XXXX-XXXX.');
            mensagens.push('celular');
            temErros = true;
        }

        // Validar se a data foi selecionada
        if (!evento.dataEvento && (!dataDigitada || dataDigitada.trim() === '')) {
            setErroModalData('Por favor, selecione a data do evento.');
            mensagens.push('data do evento');
            temErros = true;
        }

        if (temErros) {
            setMensagemErro(`Verifique: ${mensagens.join(', ')}.`);
            return;
        };

        console.log("SALVANDO EVENTO...")

        setCarregarTela(false);

        try {
            if (!evento.id_Evento && veiculo.id_ClienteVeiculo) {
                const retorno = await AddSimplesEvento({
                    dataEvento: dataDigitada.trim(),
                    tipoEvento: "vistoria_evento",
                    acao: 'criar evento vistoria',
                });
                if (retorno?.id_Condutor) {
                    setOutroCondutor(false);
                    setCondutorAssociado(false);
                } else {
                    setMensagemErro('Não foi possível salvar o evento. Tente novamente.');
                    setCarregarTela(true);
                }
            } else if (evento.id_Evento && veiculo.id_ClienteVeiculo) {
                await AtualizarSimples();
            }
        } catch (error) {
            setMensagemErro('Erro ao salvar o evento. Tente novamente.');
            setCarregarTela(true);
        }
    };

    // -----------------------------------------------------

    useEffect(() => {
      if (evento.id_Evento) {
        // Fechar modal após salvar
        setNomeCondutor('');
        setCpfCondutor('');
        setCelular('');
        setDataDigitada('');
        setErroNome('');
        setErroCpf('');
        setErroCelular('');
        setErroModalData('');
      }
    }, [evento.id_Evento]);
    // ------------------------------------------

    useEffect(() => {
        if (listaPesquisa.listaCondutor.length > 0 && ConfirmarCondutor ) {
            const t = listaPesquisa.listaCondutor[0];
            dispatch({
                type: 'set_Evento',
                payload: {
                    ...evento,
                    tipoEvento: "vistoria_evento",
                    id_Condutor: t._id,
                    nomeCondutor: t.nome,
                    cpfCondutor: t.cpfCnpj,
                    telefoneCondutor: t.foneCelular ? t.foneCelular.numeroCel : '',
                }
            });
            setConfirmarCondutor(false);
        }
    }, [ConfirmarCondutor]);

    // ------------------------------------------

    useEffect(() => {
        setNomeCondutor(evento.nomeCondutor || '');
        setCpfCondutor(evento.cpfCondutor || '');
        setCelular(evento.telefoneCondutor || '');

    }, [evento.telefoneCondutor, evento.cpfCondutor, evento.nomeCondutor]);
    // ------------------------------------------

    const fecharEVoltarEscolhaCondutor = () => {
        if (playmodal.playModalEvenPlaca) {
            FecharModal(); 
            PesqIdEvento(evento.id_Evento);
        }
        setErroModalData('');
        setErroNome('');
        setErroCpf('');
        setErroCelular('');

        setCpfCondutor('');
        setNomeCondutor('');
        setCelular('');
        
        setEditandoCelular(false);
        setCelularModificado(false);
        setTipoVistoria(null);
        setOutroCondutor(false);
        setCondutorAssociado(false);
        setModalCondutor(true);

        dispatch({
            type: 'set_Evento',
            payload: {
                ...evento,
                id_Condutor: "",
                nomeCondutor: "",
                cpfCondutor: "",
                telefoneCondutor: "",
            }
        });
    };
    // -------------------------  

    useEffect(() => {
        if (paginaADD && (ConfirmarAssociado || veiculo.id_ClienteVeiculo)) {
            dispatch({
                type: 'SET_PLAYMODAL',
                payload: {
                    ...playmodal,
                    playModalEven: true,
                    playModalEvenPlaca: false,

                }
            });
        }
    }, [ConfirmarAssociado, veiculo.id_ClienteVeiculo])
    // ---------------------

    function LimparClienteVeiculo() {
        dispatch({type: 'set_limparcliente'});

        setCondutorAssociado(false); 
        setOutroCondutor(true);
    }
    
    //###################################################################################
    return (
        
        <S.div3>
            <S.DataEventoContainer>
                <S.DataEventoModal>
                    <S.DataEventoHeader>
                        <span>� {tituloExibido}</span>
                    </S.DataEventoHeader>

                    {!cliente.id_Cliente ? (
                    <>
                    <S.DataEventoInputContainer>
                        {cpfCondutor.length <= 11 ?
                        <div>
                            <span>CPF:</span>
                            <MaskedInput
                                autoFocus
                                value={cpfCondutor}
                                type='text'
                                placeholder={'000.000.000-00'}
                                mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
                                guide={false}
                                onChange={(e) => {
                                    const valor = e.target.value.replace(/\D/g, '');
                                    SetListaPesquisa('nomeItem', valor);
                                    setCpfCondutor(valor);
                                    setErroCpf('');
                                }}
                                style={{
                                    width: '90%',
                                    padding: 'clamp(8px, 2vw, 12px)',
                                    fontSize: 'clamp(12px, 3vw, 16px)',
                                    borderRadius: '3px',
                                    border: erroCpf ? '2px solid #ff4444' : '1px solid #3881ff',
                                    backgroundColor: '#353535',
                                    color: 'white',
                                    outline: 'none',
                                    height: '30px',
                                    
                                }}
                            />
                        </div>
                        :
                        <div>
                            <span>CNPJ:</span>
                            <MaskedInput
                                autoFocus
                                value={cpfCondutor}
                                type='text'
                                placeholder={'00.000.000/0000-00'}
                                mask={[/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                                guide={false}
                                onChange={(e) => {
                                    const valor = e.target.value.replace(/\D/g, '');
                                    SetListaPesquisa('nomeItem', valor);
                                    setCpfCondutor(valor);
                                    setErroCpf('');
                                }}
                                style={{
                                    width: '90%',
                                    padding: 'clamp(8px, 2vw, 12px)',
                                    fontSize: 'clamp(12px, 3vw, 16px)',
                                    borderRadius: '3px',
                                    border: erroCpf ? '2px solid #ff4444' : '1px solid #3881ff',
                                    backgroundColor: '#353535',
                                    color: 'white',
                                    outline: 'none',
                                    height: '30px',
                                    
                                }}
                            />
                        </div>
                        }
                    </S.DataEventoInputContainer>

                    {erroCpf && (
                        <S.DataEventoError>
                            ❌ {erroCpf}
                        </S.DataEventoError>
                    )}

                    <S.DataEventoInputContainer>
                        <span>NOME:</span>
                        <S.DataEventoInput
                            type='text'
                            placeholder='Digite o nome completo'
                            value={nomeCondutor}
                            hasError={!!erroNome}
                            onChange={(e) => {
                                setNomeCondutor(e.target.value);
                                setErroNome('');
                            }}
                            
                        />
                    </S.DataEventoInputContainer>

                    {erroNome && (
                        <S.DataEventoError>
                            ❌ {erroNome}
                        </S.DataEventoError>
                    )}
                    
                    <S.DataEventoInputContainer>
                        <span>Número de Celular:</span>
                        <MaskedInput
                            value={celular}
                            type='text'
                            placeholder='(99) 99999-9999'
                            mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                            guide={false}
                            onChange={(e) => {
                                setCelular(e.target.value);
                                setErroCelular('');
                            }}

                            style={{
                                width: '90%',
                                padding: 'clamp(8px, 2vw, 12px)',
                                fontSize: 'clamp(12px, 3vw, 16px)',
                                borderRadius: '3px',
                                border: '1px solid #3881ff',
                                backgroundColor: celularModificado ? '#3d3d00' : '#353535',
                                color: 'white',
                                outline: 'none',
                                height: '30px'
                            }}
                        />
                    </S.DataEventoInputContainer>

                    {erroCelular && (
                        <S.DataEventoError>
                            ❌ {erroCelular}
                        </S.DataEventoError>
                    )}
                    </>
                    ) 
                    : 
                    (
                    <>
                    <S.DataEventoInputContainer>
                        <span>Nome:</span>
                        <S.DataEventoDescription>
                            {cliente.nome}
                        </S.DataEventoDescription>
                    </S.DataEventoInputContainer>

                    <S.DataEventoInputContainer>
                        <span>CPF:</span>
                        <S.DataEventoDescription>
                            {cliente.cpfCnpj}
                        </S.DataEventoDescription>
                    </S.DataEventoInputContainer>

                    <S.DataEventoInputContainer>
                        <span>Whatsapp:</span>
                        {editandoCelular ? (
                        <MaskedInput
                            value={celular}
                            type='text'
                            placeholder='(99) 99999-9999'
                            mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                            guide={false}
                            autoFocus
                            onChange={(e) => {
                                setCelular(e.target.value);
                                setErroCelular('');
                                const celularLimpo = e.target.value.replace(/\D/g, '');
                                const eventoCelularLimpo = cliente?.celular;
                                setCelularModificado(celularLimpo !== eventoCelularLimpo);
                            }}                            

                            onBlur={() => {
                                if (celular.replace(/\D/g, '').length < 11) {
                                    setEditandoCelular(false);
                                    setCelular("");
                                    setCelularModificado(false);
                                }
                            }}

                            style={{
                                width: '90%',
                                padding: 'clamp(8px, 2vw, 12px)',
                                fontSize: 'clamp(12px, 3vw, 16px)',
                                borderRadius: '3px',
                                border: celularModificado ? '2px solid #ffcc00' : erroCelular ? '2px solid #ff4444' : '1px solid #3881ff',
                                backgroundColor: celularModificado ? '#3d3d00' : '#353535',
                                color: 'white',
                                outline: 'none',
                                height: '30px'
                            }}
                        />
                        ) 
                        : 
                        (
                        <S.DataEventoDescription onClick={() => setEditandoCelular(true)}>
                            {cliente.celular ? cliente.celular : 'Clique para adicionar celular'}
                        </S.DataEventoDescription>
                        )}
                    </S.DataEventoInputContainer>

                    {
                    erroCelular && (
                    <S.DataEventoError>
                        ❌ {erroCelular}
                    </S.DataEventoError>
                    )}
                    </>
                    )}

                    {/* ------------------ */}                    

                    {
                    !paginaADD && ConfirmarAssociado && !evento.dataEvento && !celularModificado && veiculo.id_ClienteVeiculo && tipoVistoria !== 'vistoria_cadastro' && (
                    <>
                    <S.DataEventoInputContainer>
                        <span>Data do Evento:</span>
                        <S.DataEventoInput
                            type='date'
                            value={dataDigitada}
                            max={getDataMaxima()}
                            hasError={!!erroModalData}
                            onChange={(e) => {
                                setDataDigitada(e.target.value);
                                setErroModalData('');
                            }}
                        />
                    </S.DataEventoInputContainer>

                    {erroModalData && (
                        <S.DataEventoError>
                            ❌ {erroModalData}
                        </S.DataEventoError>
                    )}
                    </>
                    )}

                    {/* ------------------- */}

                    {mensagemErro && (
                        <S.DataEventoError role="alert">
                            ❌ {mensagemErro}
                        </S.DataEventoError>
                    )}

                    <S.DataEventoButtonContainer>
                        {tipoVistoria === 'vistoria_cadastro' && veiculo.id_ClienteVeiculo ?
                        <>
                        <S.DataEventoButton
                            type='button'
                            onClick={() => {LimparClienteVeiculo()}}
                            style={{ backgroundColor: '#555', marginRight: '8px' }}
                        >
                            ALTERAR
                        </S.DataEventoButton>

                        <S.DataEventoButton
                            type='button'
                            onClick={confirmarCondutorCadastro}
                            style={{ backgroundColor: '#4CAF50' }}
                        >
                            {!cliente.id_Cliente || !veiculo.id_ClienteVeiculo ? 'ADD CLIENTE' : '✓ CONFIRMAR'}
                        </S.DataEventoButton>
                        </>

                        :

                        cliente.id_Cliente && (CondutorAssociado || paginaADD) && !ConfirmarAssociado && !celularModificado ?
                        <>
                        <S.DataEventoButton
                            type='button'
                            onClick={() => {setCondutorAssociado(false); setModalCondutor(true);}}
                            style={{ backgroundColor: '#555', marginRight: '8px' }}
                        >
                            ← VOLTAR
                        </S.DataEventoButton>

                        {(!cliente.id_Cliente || !veiculo.id_ClienteVeiculo) &&
                        <S.DataEventoButton
                            type='button'
                            onClick={() => {AddCliente_Veiculo()}}
                            style={{ backgroundColor: '#4CAF50', marginRight: '8px' }}
                        >
                            ✓ CONFIRMAR ASSOCIADO
                        </S.DataEventoButton>
                        }

                        </>

                        :

                        <>
                        <S.DataEventoButton
                            type='button'
                            onClick={fecharEVoltarEscolhaCondutor}
                            style={{ backgroundColor: '#555', marginRight: '8px' }}
                        >
                            ← FECHAR
                        </S.DataEventoButton>

                        <S.DataEventoButton
                        type='button'
                        onClick={() => {
                            celularModificado ? atualizarCelular() : 
                            !cliente.id_Cliente || !veiculo.id_ClienteVeiculo ? AddCliente_Veiculo() : SalvarEvento();
                        }}
                        >
                            {
                                celularModificado ? '📱 ATUALIZAR CELULAR' : !cliente.id_Cliente
                                ? (tipoVistoria === 'vistoria_cadastro'
                                ? 'ADD CLIENTE' : ((CondutorAssociado || paginaADD) 
                                ? 'ADD ASSOCIADO' : 'ADD CONDUTOR')) : '✓ SALVAR'
                            }
                        </S.DataEventoButton>
                        </>}
                    </S.DataEventoButtonContainer>
                </S.DataEventoModal>
            </S.DataEventoContainer>
        </S.div3>
    );
}
